import { StyleSheet } from 'lib/paypalphrodite'

const innerHeight = window.innerHeight

export default StyleSheet.create({
  container: {
    display: 'flex',
    justifyContent: 'center',
    // 230 = header height + footer height
    height: innerHeight - 230,
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    width: '600px',
    backgroundColor: '#FFF',
    paddingTop: '7.125rem',
  },
  iconHolder: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    width: '82px',
  },
  img: {
    width: '100%',
    height: '100%',
  },
  header: {},
  headerText: {
    color: '#2C2E2F',
  },
  subHeader: {},
  subHeaderText: {
    width: '300px',
    color: '#6C7378',
    textAlign: 'center',
  },
  btnHolder: {
    width: '300px',
    marginTop: '1em',
  },
  doneBtn: {
    width: '100%',
  },
})
